import { LinkIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const HyperLink = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <LinkIcon {...rest} size={Sizes[size]} color={fill} />;
};

HyperLink.displayName = 'HyperLink';
